import { useEffect, useState } from 'react';
import { CourseTemplateProps } from './model';

export const useCourses = () => {
  const [courses, setCourses] = useState<CourseTemplateProps[]>([]);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState(false);

  const fetchCourses = async () => {
    setPending(true);
    setError(false);
    try {
      const data: {
        uchiru_webinars_courses: {
          show_on_lk_main: boolean;
          full_title: string;
          short_title: string;
          date: string;
          link_for_cabmun: string;
          id: string;
          target_audience: string;
          date_short: string;
        }[];
      } = await fetch('https://uchi.ru/api/configurator/public?configs=uchiru_webinars_courses').then((res) =>
        res.json(),
      );
      setCourses(
        data.uchiru_webinars_courses.map((el) => ({
          id: el.id,
          fullTitle: el.full_title,
          date: el.date_short,
          link: el.link_for_cabmun,
          targetAudience: el.target_audience,
        })),
      );
    } catch (e) {
      console.log(e);
      setError(true);
    }
    setPending(false);
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  return { courses, pending, error, fetchCourses };
};
